<script lang="ts">
	import { Button } from "#lib/web-ui/ui/button/index.js";
	import { getTemplateContext, cloudinaryUrl } from "../template-context.svelte";
	import { ASSOCIATE_FORM_ANCHOR, associateHeader } from "../associate-page.content";

	const templateContext = getTemplateContext();
</script>

<header
	class="dark bg-background border-border sticky top-0 z-50 w-full border-b"
	data-testid="landing-header"
>
	<div class="mx-auto flex max-w-[65rem] items-center justify-between gap-4 px-4 py-3 md:px-6">
		<a href="/" class="flex items-center">
			<img
				src={cloudinaryUrl(templateContext.images.darkLogo, { width: 160 })}
				alt={templateContext.siteName}
				width="160"
				height="60"
				loading="eager"
				fetchpriority="high"
			/>
		</a>
		<Button href="#{ASSOCIATE_FORM_ANCHOR}" class="h-10 px-4 font-semibold">
			{associateHeader.formButtonLabel}
		</Button>
	</div>
</header>
